<!--
 * @Description: 评价列表页面
 * @Author: gaohc
 * @Date: 2022-08-08 16:43:52
-->
<template>
  <div class="body">
    <el-row style="margin: 25px 40px" :gutter="0" type="flex" justify="space-between" align="middle">
      <el-col :span="7" style="text-align: left">
        <span class="search-title">服务机构: </span>
        <el-select v-model="filterParams.institutionId" clearable filterable size="small"
          placeholder="请输入/选择" style="width: 215px" @change="handelChangeInst"
          :filter-method="interactionUtil.debounce((value) => commonUtil.handleListFilter(value, 'institutionList',
			      srcInstitutionList, this))"
          @visible-change="(visible) => commonUtil.handleListFilterVisibleChange(visible,
			      'institutionList', srcInstitutionList, this)">
          <el-option v-for="item in institutionList" :key="item.id" 
		  	    :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="7" style="text-align: left">
        <span class="search-title">服务医院: </span>
        <el-select v-model="filterParams.hospitalId" clearable filterable size="small"
          :filter-method="interactionUtil.debounce((value) => commonUtil.handleListFilter(value, 'hospitalList',
			      srcHospitalList, this))"
          @visible-change="(visible) => commonUtil.handleListFilterVisibleChange(visible,
			      'hospitalList', srcHospitalList, this)"
          style="width: 215px"  placeholder="请输入/选择">
          <el-option v-for="item in hospitalList" :key="item.id"
            :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="7" style="text-align: left">
        <span class="search-title">服务人员: </span>
        <el-input size="small" style="width: 215px" clearable
          placeholder="请输入姓名" v-model="filterParams.attendantNameTeleno">
        </el-input>
      </el-col>
      <el-col :span="3" style="text-align: right"></el-col>
    </el-row>
    <el-row style="margin: 25px 40px" :gutter="0" type="flex" justify="space-between" align="middle">
      <el-col :span="7" style="text-align: left">
        <span class="search-title">评价时间: </span>
        <el-date-picker v-model="dateRange" style="width: 215px" type="datetimerange"
          align="right" unlink-panels range-separator="至" :default-time="['00:00:00', '23:59:59']"
          start-placeholder="开始时间" end-placeholder="结束时间"
          :picker-options="dateRangePickerOptions" size="small">
        </el-date-picker>
      </el-col>
      <el-col :span="7" style="text-align: left; display: flex; align-items: center">
        <span style="margin-left: 15px" class="search-title">满意度: </span>
        <div class="rate-wrap" :style="{'justify-content': filterParams.degree ? 'space-around'
		      : 'flex-start'}">
          <el-rate v-model="filterParams.degree" :icon-classes="iconClasses" show-text
            :texts="rateTexts" void-icon-class="icon-rate-face-off" text-color="#657180"
            :colors="['#FF9900', '#FF9900', '#FF9900']">
          </el-rate>
          <el-button v-if="filterParams.degree" @click="handleResetRate" class="reset-rate-btn"
            size="mini" icon="el-icon-close" circle>
          </el-button>
        </div>
      </el-col>
      <el-col :span="7" style="text-align: left">
        <span class="search-title">评价类型: </span>
        <el-select v-model="filterParams.commentGenType" clearable filterable
          size="small" placeholder="请输入/选择" style="width: 215px">
          <el-option v-for="item in commentGenList" :key="item.label"
            :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="3" style="text-align: right">
        <el-button size="small" @click="handleQuery" type="primary" icon="el-icon-search">
          搜 索
        </el-button>
      </el-col>
    </el-row>
    <div class="main-line"></div>

    <el-table style="margin: 0 40px; border: 1px solid #f0f0f0" :style="tableWidth"
      ref="table" :data="dataTable" :header-cell-style="{'text-align': 'left',
      'background-color': '#EFF5FA'}">
      <el-table-column label="服务机构" min-width="10%" align="left">
        <template slot-scope="scope">
          <span v-if="scope.row.institutionText.length < 14" class="inst-name-style">
            {{scope.row.institutionText}}
          </span>
          <el-popover v-else placement="bottom" title="" width="150" trigger="hover">
            <span>{{ scope.row.institutionText }}</span>
            <span slot="reference" class="inst-name-style" style="cursor: pointer;">
              {{ scope.row.institutionText }}
            </span>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column prop="hospitalText" label="服务医院" min-width="10%" align="left">
      </el-table-column>
      <el-table-column label="订单编号" min-width="10%" align="left">
        <template slot-scope="scope">
          <span @click="checkOrderDetail(scope.row.orderId)" class="order-no-style">
            {{ scope.row.orderNo }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="attendants" label="服务人员" min-width="8%" align="left">
      </el-table-column>
      <el-table-column label="服务名称" min-width="9%" align="left">
        <template slot-scope="scope">
          <span>{{scope.row.hserviceText ? scope.row.hserviceText : '- -'}}</span>
        </template>
      </el-table-column>
      <el-table-column label="评价人" min-width="8%" align="left">
        <template slot-scope="scope">
          <span>{{ scope.row.userName ? scope.row.userName : "- -" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="满意度" min-width="12%" align="left">
        <template slot-scope="scope">
          <div class="table-rate-item">
            <el-rate :value="scope.row.degree" disabled :icon-classes="iconClasses"
              void-icon-class="icon-rate-face-off" text-color="#657180"
              disabled-void-icon-class="icon-rate-face-off"
              :colors="['#FF9900', '#FF9900', '#FF9900']">
            </el-rate>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="标签" min-width="8%" align="left">
        <template slot-scope="scope">
          <span>{{ scope.row.labels ? scope.row.labels : "- -" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="commentTime" label="评价时间" sortable min-width="10%" align="left">
        <template slot-scope="scope">
          {{ rebuildDate(scope.row.commentTime) }}
        </template>
      </el-table-column>
      <el-table-column label="评语" min-width="10%" align="left">
        <template slot-scope="scope">
          <span v-if="scope.row.commentText.length < 15">
            {{ scope.row.commentText }}
          </span>
          <el-popover v-else placement="bottom" title="" width="250" trigger="hover">
            <span>{{ scope.row.commentText }}</span>
            <span slot="reference" class="table-explain-style">
              {{ scope.row.commentText }}
            </span>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column label="用户可见" min-width="8%" align="left">
        <template slot-scope="scope">
          <el-switch v-if="!dataPvgList.includes('ORDER_2_COMMENT_CFG_CHG')" :disabled="true" v-model="scope.row.visible"
            active-color="#13ce66" :active-value="1" :inactive-value="0"
            @change="handleSwitchCommentStatus(scope.row)">
          </el-switch>
          <el-tooltip v-else class="item" effect="dark" :content="scope.row.visible 
            ? '禁用后，此条评价将对患者隐藏'
            : '启用后，此条评价将对患者显示'"
            placement="top-start">
            <el-switch :disabled="!dataPvgList.includes('ORDER_2_COMMENT_CFG_CHG')" v-model="scope.row.visible"
              active-color="#13ce66" :active-value="1" :inactive-value="0"
              @change="handleSwitchCommentStatus(scope.row)">
            </el-switch>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-row class="foot-pagination">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurPage"
        :current-page="filterParams.page" :page-sizes="pageSizes" :page-size="filterParams.pageSize"
        layout="total,prev, pager, next,sizes,jumper" :total="totalNumber" />
    </el-row>

    <!-- 订单详情 -->
    <order-details-dialog :visible="showOrderDialog" @check-collectdetails="handleSeeCollectDetails"
      @close-dialog="closeOrderDialog" :orderId="orderId">
    </order-details-dialog>

    <!-- 订单支退记录 -->
    <payment-details-dialog :visible="showCollectMoneyDialog" @close-dialog="closeDialog"
      :orderId="orderId" />
  </div>
</template>

<script>
import Util from '@/global/Util.js'
import Constant from "@/global/Constant.js";
import OrderDetails from "../ordermng/components/OrderDetails.vue";
import PaymentDetails from "../ordermng/components/PaymentDetails.vue";
import "../../../static/fonts/style.css";

export default {
  name: "CommentList",
  components: {
    "order-details-dialog": OrderDetails,
    "payment-details-dialog": PaymentDetails,
  },

  data() {
    return {
      dataPvgList: [],    //在角色配置页面上的操作权限
      filterParams: {
        hospitalId: null,
        degree: null,
        page: 1,
        pageSize: this.commonConst.PAGE_SIZE,
      },
      pageSizes: this.commonConst.PAGE_SIZES,
      totalNumber: 0,

      institutionList: [],
      srcInstitutionList: [],
      hospitalList: [],
      srcHospitalList: [],
      commentGenList: [],
      dateRange: null,
      dateRangePickerOptions: this.dateUtil.getDateRangePickerOptions(true, false),
      checkedList: [],
      dataTable: [],
      showBalanceAccountDialog: false,
      rateTexts: ["非常不满意", "不满意", "一般", "满意", "非常满意"],
      value: null,
      iconClasses: ["icon-rate-face-1", "icon-rate-face-2", "icon-rate-face-3"],

      //订单详情dialog变量
      orderId: null,
      showOrderDialog: false,

      //评估收款详情dialog变量
      showCollectMoneyDialog: false,
    };
  },

  computed: {
    tableWidth() {
      return "width:" + (this.$root.contentWidth - 80) + "px";
    },
  },

  methods: {
    handleQuery() {
      this.filterParams.begDate = this.dateRange ? this.dateUtil.dateTimeFormat(this.dateRange[0]) : null;
      this.filterParams.endDate = this.dateRange ? this.dateUtil.dateTimeFormat(this.dateRange[1]) : null;
      if (!this.filterParams.degree) this.filterParams.degree = null;

      this.filterParams.page = 1;
      this.listComments();
    },

    // 筛选条件清除星星选择
    handleResetRate() {
      this.filterParams.degree = null;
    },

    handleSwitchCommentStatus(item) {
      let status = item.visible == 1 ? "enable" : "disable";
      this.queryVisibleChange(item.id, status);
    },

    //切换选择服务机构
    handelChangeInst(val) {
      this.filterParams.hospitalId = null;
      this.queryHspListFromInstId(val);
    },

    //根据服务机构Id查询对应机构下的医院列表
    async queryHspListFromInstId(instId) {
      let data = await Util.queryHspListFromInstId(instId, this);
      this.hospitalList = data.hospitalList;
      this.srcHospitalList = data.hospitalList;
    },

    queryVisibleChange(commentId, status) {
      let params = {
        commentId: commentId,
        visible: status
      }
      let header = this.encryptionUtil.signatureParams(params,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'PUT',
        url: Constant.URL_UPDATE_COMMENT_VISIBLE,
        param: params,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED,
      };
      this.vueRequest(requestData).then(result => {
        if (result ==  null) {
          return
        }
        this.listComments();
      });
    },

    //查看订单详情
    checkOrderDetail(orderId) {
      this.orderId = orderId;
      this.showOrderDialog = true;
    },

    //查看评估详情
    handleSeeCollectDetails() {
      this.showCollectMoneyDialog = true;
    },

    closeOrderDialog() {
      this.showOrderDialog = false;
    },

    //关闭评估收款详情对话框
    closeDialog() {
      this.showCollectMoneyDialog = false;
    },

    //以下是分页控件操作
    handleSizeChange(val) {
      this.filterParams.pageSize = val;
      this.listComments();
    },

    handleCurPage(curPage) {
      this.filterParams.page = curPage;
      this.listComments();
    },

    rebuildDate(date) {
      return this.dateUtil.dateFormat(date);
    },

    //获取查询过滤条件
    getFilterDo() {
      return new Promise((resolve) => {
        this.appAxios("GET", Constant.URL_GET_COMMENT_FILTER_DO).then((result) => {
          if (result == null) {
            return
          }
          this.institutionList = result.data.institutionList;
          this.srcInstitutionList = result.data.institutionList;
          this.hospitalList = result.data.hospitalList;
          this.srcHospitalList = result.data.hospitalList;
          this.commentGenList = this.commonUtil.map2List(result.data.commentGenMap, false,
            "value", "label");
          resolve();
        })
      });
    },

    listComments() {
      return new Promise((resolve) => {
        if (!this.filterParams.degree) this.filterParams.degree = null;
        if (this.filterParams.hasOwnProperty('hospitalId') && this.filterParams.hospitalId == null) {
          delete this.filterParams.hospitalId;
        }
        if (this.filterParams.hasOwnProperty('degree') && this.filterParams.degree == null) {
          delete this.filterParams.degree;
        }
        if (this.filterParams.hasOwnProperty('begDate') && this.filterParams.begDate == null) {
          delete this.filterParams.begDate;
        }
        if (this.filterParams.hasOwnProperty('endDate') && this.filterParams.endDate == null) {
          delete this.filterParams.endDate;
        }
        let header = this.encryptionUtil.signatureParams(this.filterParams,
          Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
        let requestData = {
          method: 'GET',
          url: Constant.URL_PAGE_COMMENTS,
          param: this.filterParams,
          header: header,
          contentType: this.commonConst.CNTYPE_URLENCODED,
        };
        this.vueRequest(requestData).then(result => {
          if (result == null) {
            return
          }

          this.dataTable = result.data;
          this.totalNumber = result.totalNumber;
          resolve();
        })
      });
    },

    getDataPvg4CurRole() {
      let requestData = {
        method: 'GET',
        url: this.commonUrl.URL_GET_DATA_PVG_4_CURROLE,
        param: {entityKey: 'ORDER'},
      };
      this.vueRequest(requestData).then(result => {
        if (result != null) {
          this.dataPvgList = result.data;
        }
      })
    },

    async initView() {
      this.getDataPvg4CurRole();
      await this.getFilterDo();
      await this.listComments();
    },
  },

  mounted() {
    this.$emit("breadcrumb", {text1: "机构管理", text2: "评价列表"});
    this.initView();
  },
};
</script>

<style scoped>
.body {
  margin: 0;
  text-align: center;
  border: solid 0px;
}

.search-title {
  color: #657180;
  font-size: 14px;
  margin-right: 9px;
}

.main-line {
  height: 10px;
  background-color: #f0f0f0;
  margin: 15px 0;
}

.foot-pagination {
  margin-top: 57px;
  text-align: right;
  right: 40px;
  border: solid 0px;
}

.table-explain-style {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}

.rate-wrap {
  display: flex;
  align-items: center;
  width: 75%;
  padding-left: 5px;
}

.reset-rate-btn {
  padding: 3px;
  background-color: #ff4f4f;
  color: #ffffff;
}

.table-rate-item {
  min-height: 60px;
  display: flex;
  align-items: center;
}

.table-rate-item /deep/ .el-rate .el-rate__item .icon-rate-face-off {
  color: rgb(198, 209, 222) !important;
}

.table-rate-item /deep/ .el-rate .el-rate__item {
  margin-bottom: 4px;
}

.inst-name-style {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.order-no-style {
  color: #3e7ef5; 
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
</style>



// WEBPACK FOOTER //
// src/components/instmng/CommentList.vue